var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveBatteryLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 428,
    height: 153,
    viewBox: "0 0 428 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_4",
    x: 0,
    y: 32,
    width: 119,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_4-2",
    x: 101,
    y: 32,
    width: 121,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_4-3",
    x: 204,
    y: 32,
    width: 121,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_4-4",
    x: 307,
    y: 32,
    width: 121,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2694",
    "data-name": "Raggruppa 2694",
    transform: "translate(-296 -492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tag_off",
    transform: "translate(311 539.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -47.13)",
    filter: "url(#Ellisse_4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_4-5",
    "data-name": "Ellisse 4",
    cx: 44.5,
    cy: 45.5,
    rx: 44.5,
    ry: 45.5,
    transform: "translate(15 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_583",
    "data-name": "Rettangolo 583",
    transform: "translate(28 18.868)",
    fill: "none",
    stroke: "#e45a39",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 49,
    rx: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 48,
    rx: 16,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_tag_on_100",
    transform: "translate(412.246 539.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -116.25, -47.13)",
    filter: "url(#Ellisse_4-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4-6",
    "data-name": "Ellisse 4",
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    transform: "translate(116 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_583-2",
    "data-name": "Rettangolo 583",
    transform: "translate(29.754 18.868)",
    fill: "none",
    stroke: "#38b29f",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 49,
    rx: 15.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 28,
    height: 46,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_584",
    "data-name": "Rettangolo 584",
    transform: "translate(29.754 18.868)",
    fill: "#38b29f",
    stroke: "#38b29f",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 49,
    rx: 15.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 28,
    height: 46,
    rx: 14,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_tag_on_75",
    transform: "translate(515.237 539.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -219.24, -47.13)",
    filter: "url(#Ellisse_4-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4-7",
    "data-name": "Ellisse 4",
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    transform: "translate(219 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_583-3",
    "data-name": "Rettangolo 583",
    transform: "translate(27.763 18.868)",
    fill: "none",
    stroke: "#eac81c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 51,
    rx: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 50,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_1084",
    "data-name": "Tracciato 1084",
    transform: "translate(28.665 15.729)",
    fill: "#eac81c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.32301902770996 52.04415893554688 C 12.36364936828613 52.04415893554688 8.64125919342041 50.50230026245117 5.841558933258057 47.70259857177734 C 3.041858911514282 44.90290069580078 1.499999046325684 41.18051910400391 1.499999046325684 37.22114944458008 L 1.499999046325684 22 L 16.32301902770996 22 L 31.14603996276855 22 L 31.14603996276855 37.22114944458008 C 31.14603996276855 41.18051910400391 29.60417938232422 44.90290069580078 26.80447959899902 47.70259857177734 C 24.00477981567383 50.50230026245117 20.28238868713379 52.04415893554688 16.32301902770996 52.04415893554688 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.999998092651367 23.5 L 2.999998092651367 37.22114944458008 C 2.999998092651367 40.77985763549805 4.385839462280273 44.12555694580078 6.902219772338867 46.64193725585938 C 9.418609619140625 49.15832901000977 12.76430892944336 50.54415893554688 16.32301902770996 50.54415893554688 C 19.88172912597656 50.54415893554688 23.2274284362793 49.15832901000977 25.74382019042969 46.64193725585938 C 28.26019859313965 44.12555694580078 29.64603805541992 40.77985763549805 29.64603805541992 37.22114944458008 L 29.64603805541992 23.5 L 2.999998092651367 23.5 M 0 20.5 C 0 20.5 7.308059692382812 20.5 16.32301902770996 20.5 C 25.33797836303711 20.5 32.64603805541992 20.5 32.64603805541992 20.5 L 32.64603805541992 37.22114944458008 C 32.64603805541992 46.23609924316406 25.33797836303711 53.54415893554688 16.32301902770996 53.54415893554688 C 7.308059692382812 53.54415893554688 0 46.23609924316406 0 37.22114944458008 L 0 20.5 Z",
    stroke: "none",
    fill: "#eac81c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_tag_on_25",
    transform: "translate(618.228 539.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -322.23, -47.13)",
    filter: "url(#Ellisse_4-4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4-8",
    "data-name": "Ellisse 4",
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    transform: "translate(322 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_583-4",
    "data-name": "Rettangolo 583",
    transform: "translate(27.772 18.868)",
    fill: "none",
    stroke: "#c45730",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 51,
    rx: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 50,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_1084-2",
    "data-name": "Tracciato 1084",
    transform: "translate(28.236 11.45)",
    fill: "#c45730"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.3040599822998 56.32300567626953 C 12.35172557830811 56.31811904907227 8.636816024780273 54.77671432495117 5.841558933258057 51.9814567565918 C 3.398485898971558 49.53838348388672 1.913206458091736 46.39262771606445 1.574458122253418 42.99999618530273 L 30.59600830078125 42.99999618530273 C 30.06365203857422 44.48011779785156 29.15417861938477 46.65213775634766 27.78794860839844 48.80930709838867 C 26.41345977783203 50.97951507568359 24.85116958618164 52.71072769165039 23.14447975158691 53.9548454284668 C 21.07966613769531 55.46000671386719 18.7782096862793 56.25672149658203 16.3040599822998 56.32300567626953 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.337137222290039 44.49999618530273 C 3.889636993408203 46.91283416748047 5.108776092529297 49.12734603881836 6.902219772338867 50.92079544067383 C 9.409547805786133 53.42811584472656 12.74047088623047 54.81302261352539 16.28483009338379 54.82296371459961 C 20.26581192016602 54.70881652832031 23.69623756408691 52.43629455566406 26.48183822631836 48.06790542602539 C 27.26602935791016 46.8381462097168 27.89356422424316 45.59938430786133 28.38033294677734 44.49999618530273 L 3.337137222290039 44.49999618530273 M 0 41.49999618530273 L 32.64603805541992 41.49999618530273 C 32.64603805541992 41.49999618530273 28.62405967712402 57.51225662231445 16.32301902770996 57.82301712036133 C 7.308059692382812 57.82301712036133 0 50.51494598388672 0 41.49999618530273 Z",
    stroke: "none",
    fill: "#c45730"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_100_",
    "data-name": "100%",
    transform: "translate(430 517)",
    fill: "#413333",
    fontSize: 24,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100%")), /*#__PURE__*/React.createElement("text", {
    id: "_75_",
    "data-name": "75%",
    transform: "translate(540 517)",
    fill: "#413333",
    fontSize: 24,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "75%")), /*#__PURE__*/React.createElement("text", {
    id: "_25_",
    "data-name": "25%",
    transform: "translate(643 517)",
    fill: "#413333",
    fontSize: 24,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25%")), /*#__PURE__*/React.createElement("text", {
    id: "Off",
    transform: "translate(339 517)",
    fill: "#413333",
    fontSize: 24,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Off")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBatteryLegend);
export default __webpack_public_path__ + "static/media/move_battery_legend.468a66fb38c70296705a281f9a47ac2b.svg";
export { ForwardRef as ReactComponent };